import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GuardsModule } from '~app/shared/guards/guards.module';
import { NoMobileGuard } from '~app/shared/guards/no-mobile.guard';
import { AuthorizationGuard } from '~app/shared/security/authorization-guard';
import { SubscriptionFormComponent } from './subscription-form/subscription-form.component';
import { SubscriptionPeriodSelectionComponent } from './subscription-period-selection/subscription-period-selection.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'index',
    pathMatch: 'full'
  },
  {
    path: 'index',
    component: SubscriptionPeriodSelectionComponent,
  },
  {
    path: 'form/:year',
    component: SubscriptionFormComponent,
    canActivate: [AuthorizationGuard, NoMobileGuard],
  }
  ,
  {
    path: 'notice/:noticeId',
    component: SubscriptionFormComponent,
    canActivate: [AuthorizationGuard, NoMobileGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), GuardsModule],
  exports: [RouterModule],
})
export class SubscriptionFarpOdqRoutingModule { }
